import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  FormGroup,
  Label,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import LogoUploader from '../../LogoUploader';

const AdminPageEditSidebarLogoUploader = ({
  page,
  handleChange,
}) => {
  const intl = useIntl();

  const [logoUrl, setLogoUrl] = useState(page.options.logo_url);
  const [logoPreviewUrl, setLogoPreviewUrl] = useState(page.options.logo_url_preview);
  const [isLogoDirty, setIsLogoDirty] = useState(false);

  useEffect(() => {
    if (isLogoDirty) {
      handleChange({
        target: {
          name: 'logo_url',
          value: logoUrl,
        },
      });
    }
  }, [logoUrl, isLogoDirty, handleChange]);

  if (page.options.page_type === 'internal') {
    return null;
  }

  return (
    <FormGroup className="logo-uploader">
      <Label>
        <span>{intl.formatMessage({ defaultMessage: 'Logo' })}</span>
        {logoPreviewUrl && (
          <Button
            color="link"
            onClick={() => {
              setIsLogoDirty(true);
              setLogoUrl(null);
              setLogoPreviewUrl(null);
            }}
          >
            <i className="far fa-trash" />
          </Button>
        )}
      </Label>
      <div className="image-container">
        <div className="image-wrapper">
          {logoPreviewUrl && (
            <img src={logoPreviewUrl} alt="Logo" />
          )}
        </div>
        <div className="logo-buttons">
          <LogoUploader
            name="logo-uploader"
            uploadButtonText={
              logoPreviewUrl ?
                intl.formatMessage({ defaultMessage: 'Change' }) :
                intl.formatMessage({ defaultMessage: 'Upload' })
              }
            handleChangeImage={(url) => {
              setLogoUrl(url);
              setIsLogoDirty(true);
            }}
            handleChangePreview={(url) => { setLogoPreviewUrl(url); }}
          />
        </div>
      </div>
    </FormGroup>
  );
};

AdminPageEditSidebarLogoUploader.propTypes = {
  page: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default AdminPageEditSidebarLogoUploader;
